<script>
import formDialogCreate from '@/components/iglobalwin/formDialog';
import formPanelCreate from '@/components/iglobalwin/form-warps/dialog-form-panel/dialog-form-panel.js';
import { validRequired } from '@/common/elementValid.js';
import website from '@/backend/services/website/website.js'

function getFormData (_obj, vm) {
  let { attributes } = vm
  let { gmailID } = attributes
  return {
    gmailID: {
      label: 'Gmail账号',
      formType: 'sky-input',
      value: gmailID || '',
      rules: [validRequired('请输入Gmail账号')],
    },
    // templateId1: {
    //   label: '备注',
    //   formType: 'sky-textarea',
    //   value: '',
    // },
  };
}

async function submit (data) {
  try {
    let { attributes } = this
    let { members, domain, index } = attributes
    let membersCopy = _.cloneDeep(members);
    let { gmailID } = data
    let params
    if (index !== undefined) {
      membersCopy[index].account = gmailID
      params = {
        domain,
        members: [
          ...membersCopy.map(val => {
            return val.account
          }),
        ]
      }
    } else {
      params = {
        domain,
        members: [
          ...membersCopy.map(val => {
            return val.account
          }),
          gmailID
        ]
      }
    }
    await website.addGsc(params)
    this.$emit('confirm');
  } catch (error) {
    this.$message.error('创建失败');
    this.formData.loading = false;
  }
}

function cancel (self) {
  self.$emit('cancel');
}

const componentForm = formPanelCreate(
  {
    getFormData,
    submit,
    cancel,
  },
  {
    labelWidth: '90px',
  }
);

async function onShowLoad (data) {
  return data
}

export default formDialogCreate({
  name: 'gscAuthorizationForm',
  componentForm,
  onShowLoad
});
</script>

<style scoped lang="scss">
</style>
